export const handleEditorClick = (
    e: React.MouseEvent<HTMLDivElement>,
    editorRef: React.RefObject<HTMLDivElement | null>,
    selectedEl: HTMLElement | null,
    setSelectedEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>,
    setClassInput: React.Dispatch<React.SetStateAction<string>>
) => {
    if (!editorRef.current) return; // current yoksa çık

    const target = e.target as HTMLElement;
    if (!editorRef.current.contains(target)) return;

    // Eğer editor'ün kendisine tıkladıysa (boş alana)
    if (target === editorRef.current) {
        if (selectedEl) {
            selectedEl.style.outline = "";
            selectedEl.style.outlineOffset = "";
        }
        setSelectedEl(null);
        return;
    }

    // Önceki seçili elementin border'ını kaldır
    if (selectedEl && selectedEl !== target) {
        selectedEl.style.outline = "";
        selectedEl.style.outlineOffset = "";
        selectedEl.style.margin="";
    }

    // Yeni seçili elementi ata ve border ekle
    setSelectedEl(target);
    target.style.outline = "2px solid #3f51b5";
    target.style.outlineOffset = "2px";
    target.style.margin="10px";

    // class input güncelle
    setClassInput(target.className);
}
